import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  grid-area: header;
  padding-block-end: ${rem(12)};

  ${mediaQueryUp.tablet} {
    padding-block-end: ${rem(24)};
  }

  &:empty { display: none; }
`

function AccommodationPackageTileHeaderArea(props: PropsWithChildren) {
  return <Container {...props} />
}

export default AccommodationPackageTileHeaderArea
